<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 10:22:07
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-30 18:09:10
 -->
<template>
  <div class="sysHeader">
    <div class="headerContent">
      <span
        v-for="(item, index) in headerMenu"
        :key="index"
        :class="[`headerTabItem ${active === index ? active === 0 ? 'leftSelected' : 'rightSelected' : active === 0 ? 'rightUnselect' : 'leftUnselect'}`]"
        @click="goPath(item.path, index)">{{item.name}}</span>
      <div class="title">
        <img class="logo" src="/static/img/layout/logo.png" alt="">
        <span class="systemName">东方世纪系统运行大数据平台</span>
      </div>
    </div>
    <div class="realTime">{{realTime}}</div>
  </div>
</template>

<script>
import { timestampFormat } from '@/utils/timestampFormat'
export default {
  name: 'sysHeader',
  components: {
  },
  data () {
    return {
      realTime: '',
      active: 0,
      headerMenu: [
        {
          name: '产品运行监测',
          path: 'productMonitorOverview',
        },
        {
          name: '运维服务监测',
          path: 'maintenanceService',
        },
      ],
    }
  },
  methods: {
    /**
     * @description                   路由跳转
     * @param  {String}               路由名
     * @param  {Number}               索引
     * @return {Boolean}              是否结束查找
     */
    goPath (path, index) {
      console.log(path, index)
      this.$router.push({
        name: path,
      })
      this.active = index
    },
    /**
     * @description                   页面刷新时设置选中状态
     * @return {undefied}             无返回值
     */
    setRefreshSelectedStatus () {
      const matched = this.$route.matched[1].path.split('/')
      if (matched[1] === 'productMonitor') {
        this.active = 0
      } else if (matched[1] === 'maintenanceService') {
        this.active = 1
      }
    },
  },
  created () {
    setInterval(() => {
      this.realTime = timestampFormat('YYYY-mm-dd HH:MM:SS', new Date())
    }, 1000)
    this.setRefreshSelectedStatus()
  },
}
</script>

<style lang="less" scoped>
  .sysHeader {
    width: 100%;
    height: 100%;
    position: relative;
    .headerContent {
      position: relative;
      width: 78%;
      height: 100%;
      background: url('/static/img/layout/headerBg.png');
      background-size: 100% 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .headerTabItem {
        position: absolute;
        display: inline-block;
        width: 13.5%;
        height: 65%;
        text-align: center;
        font-size: 1.8vh;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-around;
        cursor: pointer;
      }
      .leftSelected {
        background: url('/static/img/layout/header-left-selected.png');
        background-size: 100% 100%;
        left: 14.5%;
        color: #FFE800;
      }
      .leftUnselect {
        background: url('/static/img/layout/header-left-unselect.png');
        background-size: 100% 100%;
        left: 14.5%;
        color: #00DED3;
      }
      .rightSelected {
        background: url('/static/img/layout/header-right-selected.png');
        background-size: 100% 100%;
        right: 14.5%;
        color: #FFE800;
      }
      .rightUnselect {
        background: url('/static/img/layout/header-right-unselect.png');
        background-size: 100% 100%;
        right: 14.5%;
        color: #00DED3;
      }
      .title {
        .logo {
          height: 76%;
          vertical-align: middle;
          margin-right: 20px;
        }
        .systemName {
          vertical-align: middle;
          font-size: 3.2vh;
          font-weight: bold;
          background-image: -webkit-linear-gradient(top, rgb(229, 237, 237), rgb(171, 203, 202));
          background-clip: text;
          -webkit-text-fill-color: transparent;
          padding-right: 10px;
          font-family: 'YouSheBiaoTiHei';
        }
      }
    }
    .realTime {
      width: 15%;
      font-family: YouSheBiaoTiHei;
      font-size: 2vh;
      font-weight: bold;
      color: #00ffee;
      position: absolute;
      right: 2%;
      top: 35%;
    }
  }
</style>
